import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL
const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

const base = `${API_URL}/admin/referral-promo`

export interface PromoRecipient {
  id: string
  name: string
  email: string
  phone: string
  affiliate_code: string
  sms_sent_at: string | null
}
export interface PromoSeen {
  id: string
  name: string
  email: string
  phone: string
  seen_at: string
}
export interface PromoData {
  ok: boolean
  template: string
  sms_configured: boolean
  recipients: PromoRecipient[]
  seen_count: number
  seen: PromoSeen[]
}
export interface SendResult {
  ok: boolean
  total: number
  sent: number
  failed: number
  skipped: number
}

export function getPromo(): Promise<{data: PromoData}> {
  return adminApi.get(base)
}
export function saveTemplate(template: string): Promise<{data: {ok: boolean}}> {
  return adminApi.post(`${base}/template`, {template})
}
export function sendTest(data: {phone: string; template: string; base_url: string}): Promise<{data: {ok: boolean; message?: string; error?: string}}> {
  return adminApi.post(`${base}/send-test`, data)
}
export function sendPromo(data: {account_ids?: string[]; all?: boolean; template: string; base_url: string}): Promise<{data: SendResult}> {
  return adminApi.post(`${base}/send`, data)
}
